import React from 'react';
import { Props as ReactSelectProps } from 'react-select';
import { IFormCellProps, ISelectOption } from 'ui-toolkit';
import { useState } from 'react';
import { NavigationItem, Select, SmallBodyText } from 'ui-toolkit';
import { rightChevron } from '../../utilities/order/magicStrings';

export enum eSelectorType {
  readonly,
  dynamic,
  dropdown,
}

interface ILenderSelectorProps extends ReactSelectProps<any>, IFormCellProps {
  isFilterEnabled?: boolean;
  selectorType: eSelectorType;
  initLenderId: string;
  lenderOptions: ISelectOption<string>[];
  onUpdate: (lenderId: ISelectOption<string>) => void;
}

export const LenderSelector: React.FC<ILenderSelectorProps> = ({
  isFilterEnabled,
  selectorType,
  onUpdate,
  initLenderId,
  lenderOptions,
  placeholder,
  ...rest
}) => {
  const transformValueToSelect = (value: string) => lenderOptions.find((t) => t.value === value);
  const initLender = transformValueToSelect(initLenderId);
  const [isActive, setActive] = useState(selectorType === eSelectorType.dropdown);
  const [lender, setLender] = useState(initLender);

  const onChange = (newLender: ISelectOption<string>) => {
    setLender(newLender);
  };
  const filterOptions = (option: ISelectOption<string>, value: string) => {
    return option.label.toLowerCase().indexOf((value || '').toLowerCase()) >= 0;
  };
  const onSubmit = () => {
    if (lender) {
      onUpdate(lender);
    }
    if (selectorType === eSelectorType.dynamic) {
      setActive(false);
    }
  };
  if (!placeholder) {
    placeholder = 'None';
  }
  return isActive ? (
    <div>
      <Select {...rest} filterOption={filterOptions} value={lender} options={lenderOptions} onChange={onChange} />
      <NavigationItem text={`Update`} isInline onClick={onSubmit} />
    </div>
  ) : (
    <SmallBodyText>
      {lender ? lender.label : placeholder}
      {selectorType === eSelectorType.dynamic && (
        <NavigationItem text={`Edit ${rightChevron}`} isInline onClick={() => setActive(true)} />
      )}
    </SmallBodyText>
  );
};
